import React from "react"
import Banner from "@/common/components/BannerNew"
import styled from "styled-components"
import { section, ButtonsWrapper } from "@/common/Mixin"
import Intro from "@/common/components/_UI/Intro"
import SectionRow from "@/common/components/_Section/SectionRow"
import ShowCaseCounter from "./Counter"
import Premise from "./Premise"
import Solution from "./Solution"
import TheySay from "./TheySay"
import SectionLine from "@/common/components/SectionLine"
import NextImg from "@/common/components/NextImg/index"
import Button from "@/common/components/_UI/Button"
import { useRouter } from "next/router"
import { useTranslation } from "next-i18next"

interface UseCaseProps {
  data: any
  next: any
}

export default function UseCase({ data, next }: UseCaseProps) {
  const router = useRouter()
  const { t } = useTranslation("useCaseCommon")

  return (
    <Wrapper>
      <Banner
        title0={data.hero.title1}
        title1={data.hero.title2}
        title2={data.hero.title3}
        desc={data.hero.desc}
        btns={data.hero.btns}
        content={<NextImg src={data.hero.hero} />}
        icon={data.hero.icon}
        themeNew={data.color}
        bigP
      />
      <CounterWrapper>
        <ShowCaseCounter data={data.showCaseCounter} themeNew={data.color} />
      </CounterWrapper>
      <SectionLine themeNew={data.color} />

      <SectionRow
        content1={
          <TheySay
            content1={data.theySays.content1}
            content2={data.theySays.content2}
            themeNew={data.color}
          />
        }
      />
      <SectionLine themeNew={data.color} />

      <SectionRow
        content1={
          <Intro
            type="center big"
            title2={t("premise.title")}
            themeNew={data.color}
          />
        }
        content2={
          <Premise
            content1={data.premise.content1}
            content2={data.premise.content2}
            result={data.premise.result}
            lineGroup={data.premise.lineGroup}
            themeNew={data.color}
          />
        }
      />
      <SectionLine themeNew={data.color} />

      <SectionRow
        content1={
          <Intro
            type="center"
            title2={data.solution.title}
            themeNew={data.color}
          />
        }
        content2={<Solution data={data.solution} themeNew={data.color} />}
      />
      <ButtonWrapper className="center">
        <Button
          content={t("button.getStarted")}
          themeNew={data.color}
          href={`/contact-us?referrer=${router.asPath}`}
          target="_blank"
        />
        <Button
          content={t("button.next")}
          type="secondary"
          themeNew={data.color}
          href={`/use-case/${next}`}
          target="_self"
        />
      </ButtonWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  width: 100%;
`
const CounterWrapper = styled.div`
  width: 100%;
  ${section()}
  padding-top:0;
  margin-top: 0;
`
const ButtonWrapper = styled(ButtonsWrapper)`
  margin: 0px auto 60px;
`
